import _ from 'lodash';

const loadMarkdownToHTML = _.once(async () => {
  const md = (await import('markdown-it')).default();

  function markdownToHTML(markdown: string): string | null {
    return md.render(markdown);
  }

  return markdownToHTML;
});

const rules: RegExp[] = [
  /^(#{1,6}|-|\+|\*|>|\d+\.) /m, // Heading, List, Blockquote
  /^(-+|=+)$/m, // Heading (with --- or ===)
  /(\*{1,3})([^*]+)\1/, // Emphasis
  /(_{1,3})([^_]+)\1/, // Emphasis
  /`(.+)`/, // Inline code
  /!?\[[^\]]+\]\([^)]+\)/, // Link, Image
];

export const isMarkdown = (text: string | null | undefined): text is string =>
  text ? rules.some((rule) => rule.test(text)) : false;

export default loadMarkdownToHTML;
